import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {
	CommunicationsResponseModel,
	GetCommunications,
} from 'domain/usecases/private/communications/get-communications';
import {GetCommunicationsParams} from '../../types';
import {getCommunications} from '../../services/getCommunications';

const useGetCommunicationsQuery = (
	params: GetCommunicationsParams,
	makeGetCommunications: GetCommunications,
	opts?: UseQueryOptions<CommunicationsResponseModel>,
) =>
	useQuery({
		queryKey: [QUERY_KEYS.GET_COMMUNICATIONS, params, makeGetCommunications],
		queryFn: ({signal}) =>
			getCommunications(makeGetCommunications).perform({...params, signal}),
		retry: 2,
		...opts,
	});

export {useGetCommunicationsQuery};
